import { render, staticRenderFns } from "./sampleBookApply.vue?vue&type=template&id=e58d05a6&scoped=true"
import script from "./sampleBookApply.vue?vue&type=script&lang=js"
export * from "./sampleBookApply.vue?vue&type=script&lang=js"
import style0 from "./sampleBookApply.vue?vue&type=style&index=0&id=e58d05a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58d05a6",
  null
  
)

export default component.exports